import { render, staticRenderFns } from "./FormSearchDocument.component.pug?vue&type=template&id=32d776c4&scoped=true&lang=pug&"
import script from "./FormSearchDocument.component.ts?vue&type=script&lang=ts&"
export * from "./FormSearchDocument.component.ts?vue&type=script&lang=ts&"
import style0 from "./FormSearchDocument.component.scss?vue&type=style&index=0&id=32d776c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d776c4",
  null
  
)

export default component.exports